module.exports = __webpack_public_path__ + "static/media/publish-event.a8df53dc.svg";